import { I18n } from "@/i18n/I18n";
import { useState, useEffect } from "react";
import { DeleteButton } from "../buttons/DeleteButton";
import { SearchList } from "../SearchList";
import { ButtonParent } from "../buttons/ButtonParent";
import { useNavigate } from "react-router-dom";
import { defaultSort, useProcedureListStore } from "@/frontend/store/ProcedureListStore";
import { PROCEDURETYPE } from "@/backend/models/procedureInstances/procedureInstanceBase";
import { Play } from "@/frontend/SVGs/Play";
import { CreateFromTemplateModal } from "./CreateFromTemplateModal";
import { BasicButton } from "../buttons/BasicButton";
import { TablePlaceholder } from "../TablePlaceholder";
import { useProcedureInstanceStore } from "@/frontend/store/ProcedureInstanceStore";

export function ProcedureList() {
  const listProcedures = useProcedureListStore((state) => state.fetchProcedureItems);
  const procedures = useProcedureListStore((state) => state.procedures);
  const runs = useProcedureListStore((state) => state.runs);
  const allProcedures = [...procedures, ...runs].sort(defaultSort);
  const deleteProcedure = useProcedureListStore((state) => state.deleteProcedureItem);
  const exportJson = useProcedureInstanceStore((state) => state.exportJson);
  const navigate = useNavigate();
  const [procedureList, setProcedureList] = useState(allProcedures);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const loadAllProcedures = async () => {
       await Promise.all([
          listProcedures(PROCEDURETYPE.PROCEDURE),
          listProcedures(PROCEDURETYPE.TEMPLATE),
          listProcedures(PROCEDURETYPE.RUN)
       ]);
     };
    void loadAllProcedures().finally(() => {
      setLoading(false);
    });
  }, [listProcedures]);

  if (loading) {
    return (
      <div className='p-3'>
        <table className='table table-hover'>
          <tbody>
            <TablePlaceholder />
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className='p-3 overflow-auto' style={{ maxHeight: '100vh', height: '100vh' }}>
      <div className='d-flex gap-3 align-items-start'>
        <h3 className='mb-0'>{I18n.get('procedures')}</h3>
        <CreateFromTemplateModal />
      </div>
      <SearchList items={allProcedures} setItems={setProcedureList} modelLabel={I18n.get('procedure')}/>
      <table className='table table-hover'>
          <thead className="sticky-top" style={{ boxShadow: 'inset 0 2px 0 #000000, inset 0 -2px 0 #000000' }}>
            <tr>
              <th>{I18n.get('title')}</th>
              <th>{I18n.get('type')}</th>
              <th>{I18n.get('actions')}</th>
            </tr>
          </thead>
        <tbody>
          {procedureList.length === 0 && (
            <tr>
              <td colSpan={2} className="text-center">{I18n.get('noProcedures')}</td>
            </tr>
          )}
          {procedureList.map((procedure) => {
            return (
              <tr key={procedure.id}>
                <td>{procedure.title}</td>
                <td>{I18n.get(procedure.procedureType)}</td>
                <td className='d-flex gap-1'>
                  <ButtonParent
                    onClick={() => void navigate(`/procedures/run/${procedure.id}`)}
                    title={I18n.get('runProcedure', { title: procedure.title })}
                    variant="primary"
                  >
                    <Play />
                  </ButtonParent>
                  <DeleteButton onDelete={() => deleteProcedure(procedure)} model='procedure' title={procedure.title}/>
                  <BasicButton onClick={() => window.location.href = `veriform://downloadProcedure?procedureId=${procedure.id}`} label={I18n.get('downloadToDesktop')} className='btn btn-sm btn-primary' />
                  <BasicButton onClick={() => exportJson(procedure.id)} label={I18n.get('exportJson')} className='btn btn-sm btn-primary' />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
